export default {"src":"/_next/static/media/plane-departure.b19b9fc3.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};